import React, {Component} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import {getCode, getOpenId} from 'Actions/auth';
import {openNotification} from 'Actions/notification';
import BindEmail from './BindEmail';
import Register from './Register';
import {setProfile, loadProfile} from 'Utils/jwtUtil';
import {T} from 'Actions/translate';

function TabContainer({children, dir}) {
    return (
        <Typography component="div" dir={dir}>
            {children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};

const styles = (theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
    },
});

class Login extends Component {
    state = {
        value: 0,
        tabContentMaxHeight: 'auto',
        // showError: false,
    };

    componentWillMount() {
        let profile = loadProfile();
        let index = profile ? profile.loginIndex : 0;
        this.getCodeRequest();

        if (index === '1') {
            this.handleChangeIndex(1);
        } else {
            this.handleChangeIndex(0);
        }

        // if (this.props.auth.isAuthenticated === 'success') {
        //   try {
        //     const { from } = this.props.location.state || {
        //       from: { pathname: "/selectCustomer" }
        //     };
        //     this.props.history.replace(from);
        //   } catch (err) {
        //     this.props.history.replace("/selectCustomer");
        //   }
        // }
    }

    handleChange = (event, value) => {
        let profile = loadProfile() || {};
        this.setState({value});
        profile.loginIndex = value;
        setProfile(profile);
    };

    handleChangeIndex = (index) => {
        let profile = loadProfile() || {};
        this.setState({value: index});
        profile.loginIndex = index;
        setProfile(profile);
    };

    /*
     * get weChat code
     */
    getCodeRequest = () => {
        let url = this.props.location.search; // Get the "?" in the url.The string after

        if (url.indexOf('?') !== -1) {
            let theRequest = {};
            let str = url.substr(1);
            let strs = str.split('&');
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split('=')[0]] = unescape(
                    strs[i].split('=')[1],
                );
            }

            this.props.getOpenId({code: theRequest.code}, this.navigateTo);
        } else {
            this.props.getCode();
        }
    };

    /*
     * Navigate To
     */
    navigateTo = (response) => {
        // if ( response.status === 'success') {
        //   this.props.history.replace('/productList');
        // }
        /* else if (response.status === 'unbind') {
        this.props.openNotification('用戶未綁定', 'danger')
      } */
    };

    render() {
        const {classes, theme} = this.props;
        const {value} = this.state;

        return (
            <div className={classes.root}>
                <AppBar
                    position="fixed"
                    color="default"
                    className="login-bar container-max-width is-fixed">
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        centered>
                        <Tab
                            className={`${
                                value === 0 ? 'active' : ''
                            } login-tab`}
                            label={
                                <React.Fragment>
                                    <span className="tab-content">
                                        {T('login')}
                                    </span>
                                    <span className="tab-tag"></span>
                                </React.Fragment>
                            }
                        />
                        <Tab
                            className={`${
                                value === 1 ? 'active' : ''
                            } login-tab`}
                            label={
                                <React.Fragment>
                                    <span className="tab-content">
                                        {T('register')}
                                    </span>
                                    <span className="tab-tag"></span>
                                </React.Fragment>
                            }
                        />
                    </Tabs>
                </AppBar>
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={this.state.value}
                    onChangeIndex={this.handleChangeIndex}>
                    <TabContainer dir={theme.direction}>
                        <div className="login-tab-content">
                            {value === 0 ? (
                                <BindEmail></BindEmail>
                            ) : (
                                <div></div>
                            )}
                        </div>
                    </TabContainer>
                    <TabContainer dir={theme.direction}>
                        <div className="login-tab-content">
                            {value === 1 ? (
                                <Register
                                    onChangeIndex={
                                        this.handleChangeIndex
                                    }></Register>
                            ) : (
                                <div></div>
                            )}
                        </div>
                    </TabContainer>
                </SwipeableViews>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {
    getCode,
    getOpenId,
    openNotification,
};

export default compose(
    withStyles(styles, {withTheme: true}),
    connect(mapStateToProps, mapDispatchToProps),
)(Login);
